import type { ImageDto } from "@/api/types";

import { UserAvatar } from "../../UserAvatar/UserAvatar";

export function CommentFieldAvatar({
  avatar,
  isDeleted,
}: {
  avatar?: ImageDto;
  isDeleted?: boolean;
}): React.ReactElement {
  return (
    <div className="size-10 shrink-0">
      <UserAvatar img={avatar} isUserDeleted={isDeleted} />
    </div>
  );
}
